<div
  class="d-flex flex-column"
  [ngClass]="{ singleSelectWrapper: selectHighLight }"
  [pTooltip]="tooltipText"
  tooltipPosition="top"
  [appendTo]="'body'"
  tooltipStyleClass="custom-tooltip"
>
  <p-select
    role="combobox"
    [options]="configData.data"
    [(ngModel)]="configData.selectedItems"
    [optionLabel]="configData.optionLabel || 'value'"
    [filter]="configData.filter"
    [placeholder]="configData.placeholder"
    [disabled]="isDisabledField || isCatPlaybackActive"
    (onChange)="onChangeHandler($event)"
    [required]="isRequiredField"
    [formControl]="singleSelectFormControl"
    [ariaLabel]="ariaLabel"
    nrSingleselectAieaProp
    [ariaRequired]="isRequiredField"
    [ngClass]="{ 'ng-dirty ng-invalid': configData.isRequiredField }"
    [scrollHeight]="'250px'"
    [attr.aria-label]="ariaLabel"
  >
    <ng-template
      let-option
      pTemplate="item"
    >
      <div
        role="option"
        [attr.aria-selected]="option === configData.selectedItems"
      >
        {{ option[configData.optionLabel || 'value'] }}
      </div>
    </ng-template>
  </p-select>
</div>
